'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var protons = require('protons');

var Block = require('ipfs-block');

var isEqualWith = require('lodash.isequalwith');

var assert = require('assert');

var each = require('async/each');

var CID = require('cids');

var codecName = require('multicodec/src/name-table');

var vd = require('varint-decoder');

var multihashing = require('multihashing-async');

var pbm = protons(require('./message.proto'));

var Entry = require('./entry');

var BitswapMessage =
/*#__PURE__*/
function () {
  function BitswapMessage(full) {
    _classCallCheck(this, BitswapMessage);

    this.full = full;
    this.wantlist = new Map();
    this.blocks = new Map();
  }

  _createClass(BitswapMessage, [{
    key: "addEntry",
    value: function addEntry(cid, priority, cancel) {
      assert(cid && CID.isCID(cid), 'must be a valid cid');
      var cidStr = cid.buffer.toString();
      var entry = this.wantlist.get(cidStr);

      if (entry) {
        entry.priority = priority;
        entry.cancel = Boolean(cancel);
      } else {
        this.wantlist.set(cidStr, new Entry(cid, priority, cancel));
      }
    }
  }, {
    key: "addBlock",
    value: function addBlock(block) {
      assert(Block.isBlock(block), 'must be a valid cid');
      var cidStr = block.cid.buffer.toString();
      this.blocks.set(cidStr, block);
    }
  }, {
    key: "cancel",
    value: function cancel(cid) {
      assert(CID.isCID(cid), 'must be a valid cid');
      var cidStr = cid.buffer.toString();
      this.wantlist.delete(cidStr);
      this.addEntry(cid, 0, true);
    }
    /*
     * Serializes to Bitswap Message protobuf of
     * version 1.0.0
     */

  }, {
    key: "serializeToBitswap100",
    value: function serializeToBitswap100() {
      var msg = {
        wantlist: {
          entries: Array.from(this.wantlist.values()).map(function (entry) {
            return {
              block: entry.cid.buffer,
              // cid
              priority: Number(entry.priority),
              cancel: Boolean(entry.cancel)
            };
          })
        },
        blocks: Array.from(this.blocks.values()).map(function (block) {
          return block.data;
        })
      };

      if (this.full) {
        msg.wantlist.full = true;
      }

      return pbm.Message.encode(msg);
    }
    /*
     * Serializes to Bitswap Message protobuf of
     * version 1.1.0
     */

  }, {
    key: "serializeToBitswap110",
    value: function serializeToBitswap110() {
      var msg = {
        wantlist: {
          entries: Array.from(this.wantlist.values()).map(function (entry) {
            return {
              block: entry.cid.buffer,
              // cid
              priority: Number(entry.priority),
              cancel: Boolean(entry.cancel)
            };
          })
        },
        payload: []
      };

      if (this.full) {
        msg.wantlist.full = true;
      }

      this.blocks.forEach(function (block) {
        msg.payload.push({
          prefix: block.cid.prefix,
          data: block.data
        });
      });
      return pbm.Message.encode(msg);
    }
  }, {
    key: "equals",
    value: function equals(other) {
      var cmp = function cmp(a, b) {
        if (a.equals && typeof a.equals === 'function') {
          return a.equals(b);
        }
      };

      if (this.full !== other.full || !isEqualWith(this.wantlist, other.wantlist, cmp) || !isEqualWith(this.blocks, other.blocks, cmp)) {
        return false;
      }

      return true;
    }
  }, {
    key: "empty",
    get: function get() {
      return this.blocks.size === 0 && this.wantlist.size === 0;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      var list = Array.from(this.wantlist.keys());
      var blocks = Array.from(this.blocks.keys());
      return "BitswapMessage <full: ".concat(this.full, ", list: ").concat(list, ", blocks: ").concat(blocks, ">");
    }
  }]);

  return BitswapMessage;
}();

BitswapMessage.deserialize = function (raw, callback) {
  var decoded;

  try {
    decoded = pbm.Message.decode(raw);
  } catch (err) {
    return setImmediate(function () {
      return callback(err);
    });
  }

  var isFull = decoded.wantlist && decoded.wantlist.full || false;
  var msg = new BitswapMessage(isFull);

  if (decoded.wantlist) {
    decoded.wantlist.entries.forEach(function (entry) {
      // note: entry.block is the CID here
      var cid;

      try {
        cid = new CID(entry.block);
      } catch (err) {
        return callback(err);
      }

      msg.addEntry(cid, entry.priority, entry.cancel);
    });
  } // Bitswap 1.0.0
  // decoded.blocks are just the byte arrays


  if (decoded.blocks.length > 0) {
    return each(decoded.blocks, function (b, cb) {
      multihashing(b, 'sha2-256', function (err, hash) {
        if (err) {
          return cb(err);
        }

        var cid;

        try {
          cid = new CID(hash);
        } catch (err) {
          return callback(err);
        }

        msg.addBlock(new Block(b, cid));
        cb();
      });
    }, function (err) {
      if (err) {
        return callback(err);
      }

      callback(null, msg);
    });
  } // Bitswap 1.1.0


  if (decoded.payload.length > 0) {
    return each(decoded.payload, function (p, cb) {
      if (!p.prefix || !p.data) {
        cb();
      }

      var values = vd(p.prefix);
      var cidVersion = values[0];
      var multicodec = values[1];
      var hashAlg = values[2]; // const hashLen = values[3] // We haven't need to use this so far

      multihashing(p.data, hashAlg, function (err, hash) {
        if (err) {
          return cb(err);
        }

        var cid;

        try {
          cid = new CID(cidVersion, codecName[multicodec.toString('16')], hash);
        } catch (err) {
          return callback(err);
        }

        msg.addBlock(new Block(p.data, cid));
        cb();
      });
    }, function (err) {
      if (err) {
        return callback(err);
      }

      callback(null, msg);
    });
  }

  callback(null, msg);
};

BitswapMessage.Entry = Entry;
module.exports = BitswapMessage;